import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import * as z from 'zod'
import { ZodType } from 'zod'

import { getPeriods } from '../../../api/periods/get-periods'
import { TripPriceInput } from '../../../lib/types/models/trip-price/trip-price-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import {
  createNumberArraySchema,
  createNumberSchema
} from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledMultiSelectInput from '../../elements/inputs/controlled-multi-select-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<TripPriceInput, true> & {
  className?: string
}

export const tripPriceFormSchema: ZodType<TripPriceInput> = z.object({
  price: createNumberSchema('prix'),
  periods: createNumberArraySchema('période', { minimumNumberOfItems: 1 })
})

const TripPriceForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<TripPriceInput>({
    resolver: zodResolver(tripPriceFormSchema),
    defaultValues,
    mode: FORM_MODE
  })

  const { data: periods } = useQuery({
    queryKey: ['periods'],
    queryFn: () => getPeriods({ version: 'BASIC' })
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex gap-4 flex-col', className)}>
          <FormField
            control={form.control}
            name={'price'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput
                    required
                    {...field}
                    label={'Prix de base (€)'}
                    type={'number'}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'periods'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledMultiSelectInput
                    required
                    {...field}
                    dropDownPosition="above"
                    variant={'primary'}
                    label={'Périodes'}
                    options={periods?.data.map((period) => ({
                      label: period.name,
                      value: period.id
                    }))}
                    selectedOptions={field.value?.map((id) => ({
                      label: periods?.data.find((period) => period.id === id)?.name ?? '',
                      value: id
                    }))}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons hasBorderTop {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default TripPriceForm
